import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { MAGENTA } from 'ai-components-ui-library/styles/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const ICON_CONTAINER_SIZE_RATIO = 0.6;
const IconContainer = styled.div.withConfig({
  displayName: "AiActionIcon__IconContainer",
  componentId: "sc-1fgx50r-0"
})(["width:", "px;height:", "px;border-radius:50%;display:flex;align-items:center;justify-content:center;border:2px solid ", ";"], ({
  size
}) => size, ({
  size
}) => size, MAGENTA[400]);
const Icon = styled(UIIcon).withConfig({
  displayName: "AiActionIcon__Icon",
  componentId: "sc-1fgx50r-1"
})(["margin-top:1px;"]);
function ActionIcon({
  // The size of the icon itself, the circle will always be larger by an inverse factor of ICON_CONTAINER_SIZE_RATIO
  size = 20
}) {
  return /*#__PURE__*/_jsx(IconContainer, {
    size: Math.round(size / ICON_CONTAINER_SIZE_RATIO),
    children: /*#__PURE__*/_jsx(Icon, {
      name: "breezeSingleStar",
      size: size,
      color: MAGENTA[400]
    })
  });
}
export default ActionIcon;